import { useGateValue } from "@statsig/react-bindings";

/**
 * Whether the T&C contract-signing feature is available to this organization.
 *
 * The same gate is evaluated independently by interlude, which is what actually
 * withholds the data — this only decides whether the pages are reachable, so
 * the sidebar and the routes agree instead of the routes being open to anyone
 * who types the URL.
 */
export const useEnableContractSigning = (): boolean =>
  useGateValue("enable_contract_signing");
